import { Box, Card, CardContent, styled } from "@mui/material";

export const TipCard = styled(Card)`
  border: 1px dashed ${({ theme }) => theme.palette.divider};
  background-color: transparent;
  border-radius: ${({ theme }) => theme.spacing(1)};
`;

export const TipCardContent = styled(CardContent)`
  font-size: ${({ theme }) => theme.typography.size.small};
  color: ${({ theme }) => theme.palette.text.primary};
  &,
  &:last-child {
    padding: ${({ theme }) => theme.spacing(0, 2, 1)};
  }
`;

export const TipTitle = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ theme }) => theme.typography.size.normal};
`;
